import { createAxiosInstance } from 'app/agriculture/queries/createAxiosInstance';
import { ConfigService } from 'app/config/config.service';
import { LOCAL_STORAGE_KEY } from 'app/shared/auth/services/login_auth_service';

export async function logout() {
    const instance = createAxiosInstance({ baseURL: ConfigService.apiUrlRoot });
    const {
        data: { oidcLogoutUrl },
    } = await instance.post<{ oidcLogoutUrl: string }>('/auth/custom_logout/');
    localStorage.removeItem(LOCAL_STORAGE_KEY);
    window.location.href = `${oidcLogoutUrl}&post_logout_redirect_uri=${encodeURIComponent(window.location.origin)}`;
}
